import styled from "styled-components";

export const ButtonObervationContainer = styled.div`
  display: flex;
  width: 10%;
  height: 10%;
`;
